<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TSe8UM/tc-custom/9780292736450.jpg?1726617358971" alt="This image is the cover for the book Henry J. Kaiser"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Henry J. Kaiser
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“</b><b>His standing as a lesser-known in a business pantheon that would include such names as Ford and Carnegie makes this work of some scholarly importance.” —<i>Library Journal</i></b></p><p> In the 1940s Henry J. Kaiser was a household name, as familiar then as Warren Buffett and Donald Trump are now. Like a Horatio Alger hero, Kaiser rose from lower-middle-class origins to become an enormously wealthy entrepreneur, building roads, bridges, dams, and housing. He established giant businesses in cement, aluminum, chemicals, steel, health care, and tourism. During World War II, his companies built cargo planes and Liberty ships. After the war, he manufactured the Kaiser-Frazer automobile. Along the way, he also became a major force in the development of the western United States, including Hawaii. </p><p><i>Henry J. Kaiser: Builder in the Modern American West</i> is the first biography of this remarkable man. Drawing on a wealth of archival material never before utilized, Mark Foster covers Kaiser’s entire life (1882–1967), painting an evenhanded portrait of a man of driving ambition and integrity, demonstrating Kaiser as the prototypical “frontier” entrepreneur who often used government and union support to tame the “wilderness.” </p><p> Today the Kaiser legacy remains great. Kaiser played a major role in building the Hoover, Bonneville, Grand Coulee, and Shasta dams. The Kaiser-Permanente Medical Care Program still provides comprehensive health care for millions of subscribers. Kaiser-planned communities remain in Los Angeles; San Francisco; Portland, Oregon; and Boulder City, Nevada. Kaiser Engineers was actively engaged in hundreds of huge construction jobs across the nation and around the world. </p><p> US and business historians, scholars of the modern West, and general readers will find much to absorb in this well-written biography. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark S. Foster
      </h2>
      
      <p class="authorDescription body article"> Mark S. Foster (1939-2016) was Professor of History at the University of Colorado at Denver. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73f649a3